// Shared pieces of the Analytics "reports" pages (Calls and Messaging) so the
// two pages look and behave the same: date presets, timezone picker options,
// chart palettes and CSV export.

export const REPORT_DATE_PICKER_LABELS = [
  { id: 1, label: 'Yesterday', duration: 1 },
  { id: 2, label: 'Last 7 Days', duration: 6 },
  { id: 3, label: 'Last 30 Days', duration: 29 },
  { id: 4, label: 'Last 90 Days', duration: 89 },
  { id: 5, label: 'Last 12 Months', duration: 'year' },
  { id: 6, label: 'Custom Date' },
];

export const REPORT_TIMEZONE_OPTIONS = [
  { id: 'auto', label: 'My Current Timezone' },
  { id: 'America/New_York', label: 'Eastern Time' },
  { id: 'America/Chicago', label: 'Central Time' },
  { id: 'America/Denver', label: 'Mountain Time' },
  { id: 'America/Phoenix', label: 'Mountain Time - Arizona' },
  { id: 'America/Los_Angeles', label: 'Pacific Time' },
  { id: 'America/Anchorage', label: 'Alaska Time' },
  { id: 'Pacific/Honolulu', label: 'Hawaii Time' },
];

export const REPORT_PIE_COLORS = ['#1976d2', '#4caf50', '#ff9800', '#e91e63', '#9c27b0', '#00bcd4'];

// Every color on the reports pages is sampled from a single spectral rainbow so
// direction, status, and categorical roles share the same saturation and
// brightness. Pinning by name keeps each role's color stable.
export const REPORT_DIRECTION_COLORS = {
  Inbound: '#3686C9', // blue
  Outbound: '#E99A38', // orange
  Automated: '#9270B5', // purple - system-sent, visually "neither side"
};

// Categorical palette for per-member / per-channel / per-ring-group charts.
// Tableau 10: vivid, well-known, designed for distinguishing many categories
// at once, and kept distinct from the direction palette so a member's color
// never reads as "Inbound".
export const REPORT_CATEGORY_COLORS = [
  '#4E79A7', // steel blue
  '#F28E2C', // warm orange
  '#E15759', // brick red
  '#76B7B2', // muted teal
  '#59A14F', // grass green
  '#EDC949', // ochre
  '#AF7AA1', // dusty purple
  '#FF9DA7', // salmon pink
  '#9C755F', // tan brown
  '#BAB0AB', // warm grey
];

export const categoryColor = (index) => REPORT_CATEGORY_COLORS[index % REPORT_CATEGORY_COLORS.length];

export function readStoredTimezone(storageKey) {
  try {
    return localStorage.getItem(storageKey) || 'auto';
  } catch {
    return 'auto';
  }
}

export function storeTimezone(storageKey, value) {
  try {
    localStorage.setItem(storageKey, value);
  } catch {
    // private mode / storage disabled
  }
}

export function downloadCsv(columns, rows, filename) {
  const escape = (val) => {
    const str = String(val ?? '');
    return str.includes(',') || str.includes('"') || str.includes('\n') ? `"${str.replace(/"/g, '""')}"` : str;
  };
  const header = columns.map((c) => escape(c.header)).join(',');
  const body = rows.map((row) => columns.map((c) => escape(typeof c.format === 'function' ? c.format(row) : row[c.key])).join(',')).join('\n');
  const blob = new Blob([`${header}\n${body}\n`], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
